var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"d-block"},[_c('span',{class:_vm.labelClass},[_vm._v(_vm._s(_vm.label))]),_c('v-text-field',_vm._g(_vm._b({staticClass:"ag-text-field"},'v-text-field',_vm.computedProps,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }